export default {
	'invoice-type': 'Fatura türü'
}